import { useContext } from "react";

import { SessionContext } from "../contexts";
import { ISessionContext } from "../types";

export const useSession = (): ISessionContext => {
    const context = useContext(SessionContext);

    if (!context) {
        throw new Error("Cannot find session context!");
    }

    return context;
};
